import { Input, Output, EventEmitter, Component, OnInit } from '@angular/core';

@Component({
    selector: 'pager',
    templateUrl: './pager.component.html'
})
export class PagerComponent implements OnInit {
    @Input() currentPage: number = 1;
    @Input() totalPages: number = 1;
    @Input() displayPages: number = 3;

    @Output() changePage = new EventEmitter<number>();

    constructor() { }

    ngOnInit() { }

    getTotalPages()
    {
        return this.totalPages;
    }

    getPages()
    {
        let displayPages = [];
        let start = 1;
        const difference = Math.ceil(this.displayPages/2);
        if(this.currentPage-difference > 1) {
            start = this.currentPage-difference;
        }
        let end = start+difference < this.totalPages ? start+difference : this.totalPages;

        let i = start;
        do {
            displayPages.push(i);
            i++;
        } while(i<=end);
        return displayPages;
    }

    goToPage(pageNum: number)
    {
        if(pageNum > 0 && pageNum <= this.totalPages)
        {
            this.currentPage = pageNum;
            this.emit();
        }
    }

    emit()
    {
        this.changePage.emit(this.currentPage);
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/pager/pager.component.ts